module.exports = new __parcel__URL__("SPIKEVAX_80777-110-96_Paperboard_Carton.c1a677f9.jpg").toString();